<template>
  <!-- 案件详情-用户信息 -->
  <div class="examination-block">
    <!-- 报案申请信息 -->
    <div class="header-block">
      <div class="card-block flex">
        <!-- 受助人信息 -->
        <el-card
          v-if="checkPermission('用户信息栏-受助人信息:查看', permList)"
          class="header-card"
        >
          <div slot="header" class="clearfix">
            <span class="bold">受助人信息</span>
            <el-button
              class="btn"
              type="text"
              :disabled="
                !checkPermission('用户信息栏-受助人信息:编辑', permList) ||
                  isCaseArchive
              "
              @click="onShowEditorDialog"
            >
              修改
            </el-button>
          </div>
          <el-row class="item-block" :gutter="10">
            <el-col :xs="24" :sm="24" :lg="12">
              <p class="list-block">
                姓名：<span class="txt">{{ caseInfo.recRealName }}</span>
              </p>
              <p class="list-block">
                曾用名：<span class="txt" style="color: red">{{ caseInfo.formerName }}</span>
              </p>
              <p class="list-block">
                身份证：<span class="txt">{{ caseInfo.recIdno }}</span>
              </p>
              <p class="list-block">
                曾用身份证号：<span class="txt" style="color: red">{{ caseInfo.formerIdCard }}</span>
              </p>
              <p class="list-block">
                性别：<span class="txt">{{ caseInfo.sexName }}</span>
              </p>
              <p class="list-block">
                联系电话：<span class="txt">{{ caseInfo.recPhoneNumber }}</span>
              </p>
              <p
                v-if="caseInfo && typeof caseInfo.recMailbox === 'string'"
                class="list-block"
              >
                邮箱：<span class="txt">{{ caseInfo.recMailbox }}</span>
              </p>
              <p
                v-if="caseInfo && typeof caseInfo.recWxNumber === 'string'"
                class="list-block"
              >
                微信：<span class="txt">{{ caseInfo.recWxNumber }}</span>
              </p>
              <p class="list-block">
                地址：<span class="txt">{{ caseInfo.recResidentAddress }}{{ caseInfo.recResidentAddress }}{{ caseInfo.recResidentAddress }}</span>
              </p>
              <p
                v-if="
                  caseInfo && typeof caseInfo.recIfMemberBusiness === 'boolean'
                "
                class="list-block"
              >
                企业账户员工：<span class="txt">{{
                  caseInfo.recIfMemberBusiness ? "是" : "否"
                }}</span>
              </p>
            </el-col>
            <el-col :xs="24" :sm="24" :lg="12">
              <p class="list-block">
                受助会员身份：<span class="txt">{{ caseInfo.memberShip }}</span>
              </p>
              <p class="list-block">
                职位状态：<span class="txt">{{ caseInfo.quitStatus }}</span>
              </p>
              <p class="list-block">
                所属机构名称：<span class="txt">{{ caseInfo.corName }}</span>
              </p>
              <p class="list-block">
                所属平台名称：<span class="txt">{{ caseInfo.procomName }}</span>
              </p>
            </el-col>
          </el-row>
        </el-card>
        <!-- 申请人信息 -->
        <el-card
          v-if="checkPermission('用户信息栏-申请人信息:查看', permList)"
          class="header-card"
        >
          <div slot="header" class="clearfix">
            <span class="bold">申请人信息</span>
            <el-button
              class="btn"
              type="text"
              :disabled="
                !checkPermission('用户信息栏-申请人信息:编辑', permList) ||
                  isCaseArchive
              "
              @click="onShowEditorDialog"
            >
              修改
            </el-button>
          </div>
          <div class="item-block">
            <p class="list-block">
              姓名：<span class="txt">{{ caseInfo.applicantName }}</span>
            </p>
            <p class="list-block">
              身份证：<span class="txt">{{ caseInfo.applicantIdno }}</span>
            </p>
            <p class="list-block">
              联系电话：<span class="txt">{{
                caseInfo.applicantPhoneNumber
              }}</span>
            </p>
            <p class="list-block">
              与受助人关系：<span class="txt">{{ caseInfo.relationship }}</span>
            </p>
            <p class="list-block">
              邮箱：<span class="txt">{{ caseInfo.applicantMailbox }}</span>
            </p>
            <p class="list-block">
              微信：<span class="txt">{{ caseInfo.applicantWxNumber }}</span>
              <template
                v-if="
                  caseInfo &&
                    caseInfo.applicantWxNumber &&
                    typeof caseInfo.applicantWxCheck === 'boolean'
                "
              >
                <span
                  v-if="caseInfo.applicantWxCheck"
                  style="color: green; font-weight: bold"
                >&nbsp;&nbsp; 已验证</span>
                <span v-else style="color: red">
                  &nbsp;&nbsp;未验证 &nbsp;&nbsp;
                  <el-button
                    class="validation-btn"
                    type="text"
                    size="medium"
                    :disabled="isCaseArchive"
                    @click="copyCheckUrl"
                  >
                    复制验证链接
                  </el-button>
                </span>
              </template>
            </p>
          </div>
        </el-card>
        <!-- 推荐人信息 -->
        <el-card
          v-if="checkPermission('用户信息栏-推荐人信息:查看', permList)"
          class="header-card"
        >
          <div slot="header" class="clearfix">
            <span class="bold">推荐人信息</span>
          </div>
          <div class="item-block">
            <p class="list-block">
              姓名：<span class="txt">{{ caseInfo.refRealName }}</span>
            </p>
            <p class="list-block">
              联系电话：<span class="txt">{{ caseInfo.refMobileNO }}</span>
            </p>
            <p class="list-block">
              类型：<span class="txt">{{ caseInfo.positions }}</span>
            </p>
            <p class="list-block">
              归属：<span class="txt">{{ caseInfo.comname }}</span>
            </p>
          </div>
        </el-card>
        <!-- 银行卡信息 -->
        <el-card
          v-if="checkPermission('用户信息栏-银行卡信息:查看', permList)"
          class="header-card"
        >
          <div slot="header" class="clearfix">
            <span class="bold">银行卡信息</span>
            <el-button
              class="btn"
              type="text"
              :disabled="
                !checkPermission('用户信息栏-银行卡信息:编辑', permList) ||
                  isCaseArchive
              "
              @click="onShowEditorDialog"
            >
              修改
            </el-button>
          </div>
          <div class="item-block">
            <p class="list-block">
              收款人姓名：<span class="txt">{{ caseInfo.payee }}</span>
            </p>
            <p class="list-block">
              银行名称：<span class="txt">{{ caseInfo.bankName }}</span>
            </p>
            <p class="list-block">
              支行名称：<span class="txt">{{ caseInfo.branchInfo }}</span>
            </p>
            <p class="list-block">
              卡号：<span class="txt">{{ caseInfo.bankCard }}</span>
            </p>
            <p class="list-block">
              联行号：<span class="txt">{{ caseInfo.bankBranchCode }}</span>
            </p>
          </div>
        </el-card>
      </div>
      <template
        v-if="
          !frontEndInfoNullState &&
            caseInfo &&
            caseInfo.productName &&
            isCaseType &&
            (checkPermission('用户信息栏-申请资格信息:查看', permList) ||
            checkPermission('用户信息栏-会员生活信息:查看', permList) ||
            checkPermission('用户信息栏-疾病信息:查看', permList) ||
            checkPermission('用户信息栏-过往健康状况:查看', permList))
        "
      >
        <div class="open-btn flex" @click="onChangeShowCardRest">
          <span class="txt">{{ !showCardRestBlock ? "查看" : "收起" }}完整申请信息</span>
          <i v-show="!showCardRestBlock" class="el-icon-arrow-down" />
          <i v-show="showCardRestBlock" class="el-icon-arrow-up" />
        </div>

        <!-- 默认收起的内容（申请资格信息、会员生活信息、疾病信息、过往健康状况） -->
        <div class="hidden-block">
          <el-collapse-transition>
            <div v-show="showCardRestBlock" class="card-block flex">
              <!-- 申请资格信息 -->
              <el-card
                v-if="checkPermission('用户信息栏-申请资格信息:查看', permList)"
                class="header-card"
              >
                <div slot="header" class="clearfix">
                  <span class="bold">申请资格信息</span>
                </div>
                <div class="item-block">
                  <p class="list-block">
                    加入互助时间：<span class="txt">{{
                      frontEndInfo.applyQualifyInfo.joinTime
                    }}</span>
                  </p>
                  <p class="list-block">
                    生效时间：<span class="txt">{{
                      frontEndInfo.applyQualifyInfo.effectiveTime
                    }}</span>
                  </p>
                  <template v-if="frontEndInfo.healthQuestion.length">
                    <p class="title-block bold">加入前健康状况确认</p>
                    <!-- 表格内容 -->
                    <el-table
                      :data="frontEndInfo.healthQuestion"
                      border
                      style="width: 100%"
                      height="250"
                    >
                      <el-table-column
                        prop="title"
                        label="项目"
                        align="center"
                      />
                      <el-table-column label="是" width="50" align="center">
                        <template slot-scope="scope">
                          <i
                            v-if="scope.row.answer"
                            class="icon-block el-icon-success"
                          />
                        </template>
                      </el-table-column>
                      <el-table-column label="否" width="50" align="center">
                        <template slot-scope="scope">
                          <i
                            v-if="!scope.row.answer"
                            class="icon-block el-icon-success"
                          />
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="content"
                        label="备注"
                        align="center"
                      />
                    </el-table>
                  </template>
                </div>
              </el-card>
              <!-- 会员生活信息 -->
              <el-card
                v-if="checkPermission('用户信息栏-会员生活信息:查看', permList)"
                class="header-card"
              >
                <div slot="header" class="clearfix">
                  <span class="bold">会员生活信息</span>
                </div>
                <div class="item-block">
                  <div class="education-block">
                    <p class="list-block bold">最高学历</p>
                    <ul
                      v-if="
                        frontEndInfo.recLifeInfo.highestDegree &&
                          frontEndInfo.recLifeInfo.highestDegree.length
                      "
                      class="list-block"
                    >
                      <li
                        v-for="(item, index) in frontEndInfo.recLifeInfo
                          .highestDegree"
                        :key="index"
                        class="li-block"
                      >
                        <div class="name-block flex">
                          <p class="name">学校名称：{{ item.school }}</p>
                          <p class="txt">
                            {{ item.admissionDate }}-{{ item.graduationDate }}
                          </p>
                        </div>
                        <p class="name">学历：{{ item.degree }}</p>
                        <p class="name">专业：{{ item.major }}</p>
                      </li>
                    </ul>
                    <p v-else class="list-block">无</p>
                  </div>

                  <div class="economic-block">
                    <p class="title-block bold">经济情况</p>
                    <ul
                      v-if="
                        (frontEndInfo.recLifeInfo.incomeInfo.companyInfo &&
                          frontEndInfo.recLifeInfo.incomeInfo.companyInfo
                            .length) ||
                          (frontEndInfo.recLifeInfo.incomeInfo.dependantInfo &&
                          frontEndInfo.recLifeInfo.incomeInfo.dependantInfo.length)
                      "
                      class="list-block"
                    >
                      <!-- 公司信息 -->
                      <li
                        v-for="(item, index) in frontEndInfo.recLifeInfo
                          .incomeInfo.companyInfo"
                        :key="index"
                        class="li-block"
                      >
                        <div class="name-block flex">
                          <p class="name">公司名称：{{ item.companyName }}</p>
                          <p class="txt">
                            {{ item.hireDate }}-{{ item.leaveDate }}
                          </p>
                        </div>
                        <p class="name">职位：{{ item.duty }}</p>
                        <p class="name">
                          年收入：{{ newAnnualIncomeArr[item.newAnnualIncome] }}
                        </p>
                        <p class="name">
                          家庭年收入：{{
                            familyAnnualIncomeArr[item.familyAnnualIncome]
                          }}
                        </p>
                      </li>
                      <!-- 抚养人信息 -->
                      <li
                        v-for="(item, index) in frontEndInfo.recLifeInfo
                          .incomeInfo.dependantInfo"
                        :key="index"
                        class="li-block"
                      >
                        <div class="name-block flex">
                          <p class="name">赡养人姓名：{{ item.name }}</p>
                        </div>
                        <p class="name">联系电话：{{ item.phoneNumber }}</p>
                        <p class="name">地址：{{ item.address }}</p>
                      </li>
                    </ul>
                    <p v-else class="list-block">无</p>
                  </div>
                </div>
              </el-card>
              <!-- 疾病信息（注意：只有抗癌互助计划才显示） -->
              <el-card
                v-if="
                  caseInfo &&
                    caseInfo.productName &&
                    isCaseType &&
                    checkPermission('用户信息栏-疾病信息:查看', permList)
                "
                class="header-card"
              >
                <div slot="header" class="clearfix">
                  <span class="bold">疾病信息</span>
                </div>
                <div class="item-block">
                  <p class="list-block">
                    互助事件类别：<span class="txt">{{
                      helpEventTypeArr[frontEndInfo.diseaseInfo.helpEventType]
                    }}</span>
                  </p>
                  <p class="list-block">
                    首次感到不舒服时间：<span class="txt">{{
                      frontEndInfo.diseaseInfo.firstDiagnosisTime
                    }}</span>
                  </p>
                  <p class="list-block">
                    首次确诊医院：<span class="txt">{{
                      frontEndInfo.diseaseInfo.firstDiagnosisHospital
                    }}</span>
                  </p>
                  <p class="list-block">
                    入院主诉症状：<span class="txt">{{
                      frontEndInfo.diseaseInfo.complaintSymptom
                    }}</span>
                  </p>
                  <p class="list-block">
                    入院陈述的主要既往病史：<span class="txt">{{
                      frontEndInfo.diseaseInfo.majorPastMedicalHistory
                    }}</span>
                  </p>
                </div>
              </el-card>
              <!-- 过往健康状况（注意：只有抗癌互助计划才显示） -->
              <el-card
                v-if="
                  caseInfo &&
                    caseInfo.productName &&
                    isCaseType &&
                    checkPermission('用户信息栏-过往健康状况:查看', permList)
                "
                class="header-card"
              >
                <div slot="header" class="clearfix">
                  <span class="bold">过往健康状况</span>
                </div>
                <div class="item-block">
                  <p class="list-block">
                    参加过的医疗保障类型：<span class="txt">{{
                      insuranceTypeObj[
                        frontEndInfo.pastHealthStatus.insuranceType
                      ]
                    }}</span>
                  </p>
                  <!-- 如果当前用户是无医保的，则不显示参保时间和参保地 -->
                  <template
                    v-if="frontEndInfo.pastHealthStatus.insuranceType !== 4"
                  >
                    <p class="list-block">
                      参保时间：<span class="txt">{{
                        frontEndInfo.pastHealthStatus.insuranceTime
                      }}</span>
                    </p>
                    <p class="list-block">
                      参保地：<span class="txt">{{
                        frontEndInfo.pastHealthStatus.insuranceArea
                      }}</span>
                    </p>
                  </template>
                  <p class="list-block">
                    体检频率：<span class="txt">{{
                      frequencyofExamObj[
                        frontEndInfo.pastHealthStatus.frequencyofExam
                      ]
                    }}</span>
                  </p>
                  <!-- 如果当前用户“没体检习惯”（frequencyofExam == 1）则不显示体检记录 -->
                  <div
                    v-if="frontEndInfo.pastHealthStatus.frequencyofExam !== 1"
                    class="record-block"
                  >
                    <p class="name bold">体检记录：</p>
                    <ul
                      v-if="
                        frontEndInfo.pastHealthStatus.physicalExamRecords &&
                          frontEndInfo.pastHealthStatus.physicalExamRecords
                            .length
                      "
                      class="msg-block"
                    >
                      <li
                        v-for="(item, index) in frontEndInfo.pastHealthStatus
                          .physicalExamRecords"
                        :key="'phy' + index"
                        class="msg-list flex"
                      >
                        <p class="msg">体检机构：{{ item.hospital }}</p>
                        <p class="txt">体检时间：{{ item.examDate }}</p>
                      </li>
                    </ul>
                    <p v-else class="msg-block">无</p>
                  </div>
                  <div class="record-block">
                    <p class="name bold">近三年就诊记录：</p>
                    <ul
                      v-if="
                        frontEndInfo.pastHealthStatus.treatmentRecords &&
                          frontEndInfo.pastHealthStatus.treatmentRecords.length
                      "
                      class="msg-block"
                    >
                      <li
                        v-for="(item, index) in frontEndInfo.pastHealthStatus
                          .treatmentRecords"
                        :key="'treat' + index"
                        class="msg-list flex"
                      >
                        <p class="msg">医疗机构：{{ item.hospital }}</p>
                        <p class="txt">就诊时间：{{ item.examDate }}</p>
                      </li>
                    </ul>
                    <p v-else class="msg-block">无</p>
                  </div>
                  <div class="record-block">
                    <p class="name bold">相关检查：</p>
                    <ul
                      v-if="
                        frontEndInfo.pastHealthStatus.relevantInspections &&
                          frontEndInfo.pastHealthStatus.relevantInspections
                            .length
                      "
                      class="msg-block"
                    >
                      <li
                        v-for="(item, index) in frontEndInfo.pastHealthStatus
                          .relevantInspections"
                        :key="'relevant' + index"
                        class="msg-list flex"
                      >
                        <p class="msg">诊断结果：{{ item.result }}</p>
                        <p class="txt">检查时间：{{ item.examDate }}</p>
                      </li>
                    </ul>
                    <p v-else class="msg-block">无</p>
                  </div>
                </div>
              </el-card>
            </div>
          </el-collapse-transition>
        </div>
      </template>
    </div>

    <!-- 沟通信息 -->
    <template
      v-if="
        checkPermission('用户信息栏-审核问题:查看', permList) ||
          checkPermission('用户信息栏-渠道信息:查看', permList) ||
          checkPermission('用户信息栏-品牌信息:查看', permList) ||
          checkPermission('用户信息栏-家庭成员背景情况:查看', permList)
      "
    >
      <v-communicateInfo @updateCaseOperationList="_updateCaseOperationList" />
    </template>

    <!-- 受助人等信息编辑-对话框 -->
    <el-dialog
      title="编辑信息"
      :visible.sync="editorDialog"
      class="edit-dialog"
      width="40%"
    >
      <ul class="content-block">
        <template
          v-if="checkPermission('用户信息栏-受助人信息:编辑', permList)"
        >
          <li class="list-block flex">
            <p class="title">受助人联系电话</p>
            <el-input
              v-model="recInfo.recPhoneNumber"
              placeholder="请输入内容"
              class="input-block"
              maxlength="11"
            />
          </li>
          <li class="list-block flex">
            <p class="title">受助人联系邮箱</p>
            <el-input
              v-model="recInfo.recMailbox"
              placeholder="请输入内容"
              class="input-block"
            />
          </li>
          <li class="list-block flex">
            <p class="title">受助人微信号</p>
            <el-input
              v-model="recInfo.recWxNumber"
              placeholder="请输入内容"
              class="input-block"
            />
          </li>
        </template>
        <template
          v-if="checkPermission('用户信息栏-申请人信息:编辑', permList)"
        >
          <li class="list-block flex">
            <p class="title">申请人联系电话</p>
            <el-input
              v-model="recInfo.applicantPhoneNumber"
              placeholder="请输入内容"
              class="input-block"
              maxlength="11"
            />
          </li>
          <li class="list-block flex">
            <p class="title">申请人联系邮箱</p>
            <el-input
              v-model="recInfo.applicantMailbox"
              placeholder="请输入内容"
              class="input-block"
            />
          </li>
          <li class="list-block flex">
            <p class="title">申请人微信号</p>
            <el-input
              v-model="recInfo.applicantWxNumber"
              placeholder="请输入内容"
              class="input-block"
            />
          </li>
        </template>

        <template
          v-if="checkPermission('用户信息栏-银行卡信息:编辑', permList)"
        >
          <li class="list-block flex">
            <p class="title">收款人</p>
            <el-input
              v-model="recInfo.payee"
              placeholder="请输入内容"
              class="input-block"
            />
          </li>
          <li class="list-block flex">
            <p class="title">开户银行</p>
            <el-input
              v-model="recInfo.bankName"
              placeholder="请输入内容"
              class="input-block"
            />
          </li>
          <li class="list-block flex">
            <p class="title">卡号</p>
            <el-input
              v-model="recInfo.bankCard"
              placeholder="请输入内容"
              class="input-block"
            />
          </li>
          <li class="list-block flex">
            <p class="title">支行信息</p>
            <el-input
              v-model="recInfo.branchInfo"
              placeholder="请输入内容"
              class="input-block"
            />
          </li>
          <li class="list-block flex">
            <p class="title">联行号</p>
            <el-input
              v-model="recInfo.bankBranchCode"
              placeholder="请输入内容"
              class="input-block"
              maxlength="15"
            />
          </li>
        </template>
      </ul>

      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="onHideEditorDialog">取 消</el-button>
        <el-button type="primary" size="small" @click="onEditSubmit">
          确 定
        </el-button>
      </div>
    </el-dialog>

    <!-- 申请人微信号验证-对话框 -->
    <el-dialog
      :visible.sync="checkUrlStatus"
      width="450px"
      append-to-body
      @open="doCopy"
    >
      <el-input
        v-model="checkUrl"
        style="width: 300px; margin-right: 5px"
        disabled
      />
      <el-button type="button" @click="doCopy">点击复制</el-button>

      <span slot="footer" class="dialog-footer">
        <el-button @click="checkUrlStatus = false">取 消</el-button>
        <el-button type="primary" @click="checkUrlStatus = false">
          确 定
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { Checkout } from "@/utils/checkout"; // 校验数据
import CommunicateInfo from "../communicateInfo"; // 沟通信息

const _checkout = new Checkout();

export default {
  name: "UserInfo",

  components: {
    "v-communicateInfo": CommunicateInfo,
  },

  data() {
    return {
      recInfo: {}, // 受助人信息
      checkUrlStatus: false, // 控制申请人微信号验证弹出窗的显示/隐藏
      checkUrl: "", // 申请人微信号验证弹出窗-验证URL地址
      editorDialog: false, // 控制申请人微信号验证弹出窗的显示/隐藏
      showCardRestBlock: false, // 控制申请信息是否显示

      // 案件完整的申请信息
      frontEndInfo: {
        applyQualifyInfo: {}, // 加入时间、生效时间
        healthQuestion: [], // 加入前健康状况确认
        recLifeInfo: {
          // 会员生活信息
          highestDegree: [], // 最高学历
          incomeInfo: {
            companyInfo: [], // 公司信息
            dependantInfo: [], // 抚养人信息
          },
        },
        diseaseInfo: {}, // 疾病信息
        pastHealthStatus: {
          // 过往健康状况
          physicalExamRecords: [], // 体检记录
          treatmentRecords: [], // 近三年就诊记录
          relevantInspections: [], // 相关检查
        },
      },
      frontEndInfoNullState: false, // 判断案件完整的申请信息是否存在

      // 【年收入】对应的全部数据
      newAnnualIncomeArr: {
        1: "无",
        2: "1-5万",
        3: "5-10万",
        4: "10-20万",
        5: "20-50万",
        6: "50万以上",
      },
      // 【家庭年收入】对应的全部数据
      familyAnnualIncomeArr: {
        1: "0-5万",
        2: "5-10万",
        3: "10-20万",
        4: "20-100万",
        5: "100万以上",
      },
      // 【互助事件类别】对应的全部数据
      helpEventTypeArr: {
        1: "癌症",
        2: "少儿呼吸道疾病",
      },
      // 【参加过的医疗保障类型】对应的全部数据
      insuranceTypeObj: {
        1: "职工医保",
        2: "居民医保",
        3: "新农合",
        4: "无医保",
      },
      // 【体检频率】对应的全部数据
      frequencyofExamObj: {
        1: "无体检习惯",
        2: "一年一次",
        3: "两年一次",
        4: "无定期",
      },
    };
  },

  // 计算属性
  computed: {
    ...mapState({
      caseInfo: (state) => state.caseDetail.caseInfo,
      permList: (state) => state.permission.permList,
    }),

    /**
     * 判断案件类型（抗癌、意外）
     */
    isCaseType() {
      const { productName } = this.caseInfo;

      return productName && productName.substring(0, 2) === "抗癌";
    },

    // 判断当前案件是否为“归档”流程
    isCaseArchive() {
      return this.caseInfo.flowCode >= 103500;
    },
  },

  // 侦听器
  watch: {
    // 监听案件详情数据的变化
    caseInfo(val, oldVal) {
      const { caseCode } = val;
      const { caseCode: oldCaseCode } = oldVal;

      if (caseCode !== oldCaseCode) this.fetchFrontEndInfo();
      if (caseCode) this.infoRecData();
    },
  },

  mounted() {
    const {
      caseInfo: { caseCode },
    } = this;
    if (caseCode) {
      this.infoRecData();
      this.fetchFrontEndInfo();
    }
  },

  methods: {
    /**
     * 初始化受助人信息
     */
    infoRecData() {
      const { caseInfo } = this;

      if (caseInfo) {
        const recInfo = {
          recPhoneNumber: caseInfo.recPhoneNumber,
          recMailbox: caseInfo.recMailbox,
          recWxNumber: caseInfo.recWxNumber,
          applicantPhoneNumber: caseInfo.applicantPhoneNumber,
          applicantMailbox: caseInfo.applicantMailbox,
          applicantWxNumber: caseInfo.applicantWxNumber,
          payee: caseInfo.payee,
          bankName: caseInfo.bankName,
          bankCard: caseInfo.bankCard,
          branchInfo: caseInfo.branchInfo,
          infoVersion: caseInfo.infoVersion,
          caseCode: caseInfo.caseCode,
          flowCode: caseInfo.flowCode,
          bankBranchCode: caseInfo.bankBranchCode,
        };

        this.recInfo = recInfo;
      }
    },

    /**
     * 获取案件申请信息
     */
    async fetchFrontEndInfo() {
      const _this = this;
      const { caseCode } = _this.caseInfo;

      // 如果当前是意外案件，则不查询案件申请信息
      if (!_this.isCaseType) return false;

      try {
        const { data: result } = await _this.axios.get(
          `/case-info/frontEndInfo?caseCode=${caseCode}`
        );
        if (result && result.status === "000000") {
          _this.frontEndInfo = result && result.data;
          _this.frontEndInfoNullState = false;
        } else {
          _this.frontEndInfoNullState = true;
          // 不存在该案件申请信息
          if (result && result.status !== "100000") {
            console.warn("获取新版审核问题-请求失败", result && result.message);
            // _this.$alert(result && result.message, '提示')
          }
        }
      } catch (error) {
        _this.frontEndInfoNullState = true;
        console.log("获取新版审核问题-请求失败", error);
      }
    },

    /**
     * 申请人微信号验证弹出窗
     */
    async copyCheckUrl() {
      const _this = this;
      const { caseCode } = _this.caseInfo;
      _this.checkUrl = "";

      try {
        const { data: result } = await _this.axios.get(
          `/applicant-wx-check/token/${caseCode}`
        );

        if (result && result.status === "000000") {
          const newResult = result && result.data;
          _this.checkUrl = newResult && newResult.url;
          _this.checkUrlStatus = true;
        } else {
          _this.$alert("获取验证链接失败！", "提示");
        }
      } catch (error) {
        console.log("生成微信验证链接-请求失败", error);
      }
    },

    /**
     * 复制链接地址
     */
    doCopy() {
      const _this = this;
      const { checkUrl } = _this;

      _this.$copyText(checkUrl).then(
        () => {
          _this.$message({ type: "success", message: "内容已复制到剪切板！" });
        },
        () => {
          _this.$message({
            type: "warning",
            message: "该浏览器不支持自动复制,请手动点击复制",
          });
        }
      );
    },

    /**
     * 显示受助人等信息编辑-对话框
     */
    onShowEditorDialog() {
      this.editorDialog = true;
    },

    /**
     * 隐藏受助人等信息编辑-对话框
     */
    onHideEditorDialog() {
      this.editorDialog = false;
    },

    /**
     * 编辑（受助人信息、申请人信息、银行卡信息）-对话框-保存按钮点击事件
     */
    onEditSubmit() {
      const {
        recInfo: {
          applicantPhoneNumber,
          applicantMailbox,
          applicantWxNumber,
          payee,
          bankName,
          bankCard,
          branchInfo,
          bankBranchCode,
        },
        permList,
      } = this;

      if (this.checkPermission("用户信息栏-申请人信息:编辑", permList)) {
        if (!applicantPhoneNumber) {
          this.$message.error("请填写申请人的联系电话");
          return false;
        } else if (_checkout.checkMobile(applicantPhoneNumber)) {
          this.$message.error("请填写申请人正确的手机号码");
          return false;
        } else if (!applicantMailbox) {
          this.$message.error("请填写申请人的联系邮箱");
          return false;
        } else if (_checkout.checkEmail(applicantMailbox)) {
          this.$message.error("请填写申请人正确的电子邮箱地址");
          return false;
        } else if (!applicantWxNumber) {
          this.$message.error("请填写申请人的微信号");
          return false;
        }
      }
      if (this.checkPermission("用户信息栏-银行卡信息:编辑", permList)) {
        if (!payee) {
          this.$message.error("请填写收款人姓名");
          return false;
        } else if (!bankName) {
          this.$message.error("请填写开户银行");
          return false;
        } else if (!bankCard) {
          this.$message.error("请填写银行卡号");
          return false;
        } else if (!branchInfo) {
          this.$message.error("请填写支行信息");
          return false;
        } else if (!bankBranchCode) {
          this.$message.error("请填写联行号");
          return false;
        }
      }
      this.onSaveRecInfo();
    },

    /**
     * 变更受助人信息
     */
    async onSaveRecInfo() {
      const _this = this;
      const { recInfo } = _this;

      try {
        const { data: result } = await _this.axios.put(
          `/case-info/apply-info`,
          recInfo
        );
        if (result && result.status === "000000") {
          _this.$alert("操作成功", "提示", {
            callback: () => {
              _this.onHideEditorDialog();

              // 重新加载案件详情信息
              _this.$emit("getcaseInfo");
            },
          });
        } else {
          _this.$alert(result && result.message, "提示");
        }
      } catch (error) {
        console.log("变更受助人信息-请求失败", error);
      }
    },

    /**
     * 修改控制申请信息的显示状态
     */
    onChangeShowCardRest() {
      this.showCardRestBlock = !this.showCardRestBlock;
    },

    /**
     * 通知父级组件-更新历史操作记录
     */
    _updateCaseOperationList() {
      this.$emit("updateCaseOperationList");
    },
  },
};
</script>

<style scoped lang="scss">
@import "./index.scss";
</style>
